import { makeEntityScaffold } from '@classpass/saga-tools';
import { transformV2ClientResponse, transformKeysToSnakeCase } from 'helpers/core';

import URLS from 'constants/urls';

const handler = ({ httpClient }, venueId, payoutId, transactionType, page) => {
  const endpoint = URLS.reports.transactions(
    transformKeysToSnakeCase({
      venueId,
      payoutId,
      transactionType,
      page,
    })
  );

  return httpClient.get(endpoint).then(transformV2ClientResponse);
};

export default makeEntityScaffold('SAGA.API.REPORTS_TRANSACTIONS', handler);
